<span
  class="pr-3"
  ngbTooltip="{{ 'documents.document-item-inventory-qty.tooltip' | translate }}"
  placement="left"
  *ngIf="hasInventory$ | async"
>
  <i class="fe fe-package mr-1"></i> {{ inventory$ | async }}
</span>
